import { useEffect, useRef } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { invalidateGuildData } from "@/lib/api/guilds";
import { useDashboardWS } from "@/hooks/use-websocket";

export function useGuildAddedListener({
  discordGuildId,
  onSuccess,
}: {
  discordGuildId?: string;
  onSuccess: () => void;
}) {
  const queryClient = useQueryClient();
  const { addListener } = useDashboardWS();
  const onSuccessRef = useRef(onSuccess);
  useEffect(() => {
    onSuccessRef.current = onSuccess;
  });

  useEffect(() => {
    const remove = addListener((msg) => {
      if (msg.type !== "guild:added") return;
      if (discordGuildId && msg.discordGuildId !== discordGuildId) return;

      invalidateGuildData(queryClient);
      toast.success(`Bot added to ${msg.guildName ?? "server"} successfully`);
      onSuccessRef.current();
    });
    return remove;
  }, [queryClient, addListener, discordGuildId]);
}
